module.exports = __webpack_public_path__ + "static/share_V1-c1270f02ec9b4ad743e23972a0187469.mp4";